"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _glamor = require("glamor");

var _Prompt = require("@quixeltools/quixel-ui-library/dist/components/bridge/popups/Prompt");

var _Prompt2 = _interopRequireDefault(_Prompt);

var _IconWithDescription = require("@quixeltools/quixel-ui-library/dist/components/megascans/marketing/IconWithDescription");

var _IconWithDescription2 = _interopRequireDefault(_IconWithDescription);

var _IconWithDescriptionAndLink = require("@quixeltools/quixel-ui-library/dist/components/megascans/marketing/IconWithDescriptionAndLink");

var _IconWithDescriptionAndLink2 = _interopRequireDefault(_IconWithDescriptionAndLink);

var _IconWithDescriptionAndLinkInColumn = require("@quixeltools/quixel-ui-library/dist/components/megascans/marketing/IconWithDescriptionAndLinkInColumn");

var _IconWithDescriptionAndLinkInColumn2 = _interopRequireDefault(_IconWithDescriptionAndLinkInColumn);

var _components = require("../../components");

var _user = require("../../redux/modules/user");

var _fonts = require("@quixeltools/quixel-ui-library/dist/utils/fonts");

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _softwares = require("redux/modules/softwares");

var _utils = require("utils");

var _customProtocolDetection = require("../../utils/customProtocolDetection");

var _redial = require("redial");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var listPromotion = [{
  logo: "https://d3uwib8iif8w1p.cloudfront.net/quixel/icons/megascans_icon_2048_preview.png",
  title: "Megascans",
  description: "Access to the free section of the world’s largest and fastest growing scan library."
}, {
  logo: "https://d3uwib8iif8w1p.cloudfront.net/quixel/icons/bridge_icon_2048.png",
  title: "Bridge",
  description: "The complete management and integrations solution."
}, {
  logo: "https://d3uwib8iif8w1p.cloudfront.net/quixel/icons/mixer_icon_2048_preview.png",
  title: "Mixer",
  description: "Blend, paint & sculpt tileable materials in no-time."
}];

var listPromotion3 = [{
  logo: "https://d3uwib8iif8w1p.cloudfront.net/quixel/icons/megascans_icon_2048_preview.png",
  title: "Megascans",
  description: "Points allowance to download from the world’s largest 3D asset library."
}, {
  logo: "https://d3uwib8iif8w1p.cloudfront.net/quixel/icons/bridge_icon_2048.png",
  title: "Bridge",
  description: "The complete management and integrations solution."
}, {
  logo: "https://d3uwib8iif8w1p.cloudfront.net/quixel/icons/mixer_icon_2048_preview.png",
  title: "Mixer",
  description: "Blend, paint & sculpt tileable materials in no-time."
}, {
  logo: "https://d3uwib8iif8w1p.cloudfront.net/quixel/icons/gift.png",
  title: "Bonus assets",
  description: "New free bonus assets added every month."
}];

var listing = (0, _glamor.css)({
  marginBottom: 24, //48,
  flexBasis: "33.33%",
  ":last-child": {
    marginBottom: 0
  }
});

var listing2 = (0, _glamor.css)({
  marginBottom: 48,
  flexBasis: "33.33%",
  ":last-child": {
    marginBottom: 0
  }
});

var p = (0, _glamor.css)(_fonts.popupTextbtn, {
  marginBottom: "50px"
});

var container = (0, _glamor.css)({
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "space-between"
});

var TrialPopup = (_dec = (0, _redial.provideHooks)({
  defer: function defer(_ref) {
    var dispatch = _ref.store.dispatch;

    return dispatch((0, _softwares.loadMixerUpdater)());
  }
}), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    activating: state.user.activatingTrial,
    activated: state.user.activatedTrial,
    error: state.user.trialError,
    user: state.user,
    softwares: state.softwares
  };
}, { activateTrial: _user.activateTrial }), _dec(_class = _dec2(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(TrialPopup, _React$Component);

  function TrialPopup(props) {
    (0, _classCallCheck3.default)(this, TrialPopup);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TrialPopup.__proto__ || (0, _getPrototypeOf2.default)(TrialPopup)).call(this, props));

    _this.state = {
      message: null,
      error: null,
      platform: "Windows",
      bridgeNotFound: true,
      mixerNotFound: true
    };

    _this.onSubscribeClick = _this.onSubscribeClick.bind(_this);
    _this.onTrialClick = _this.onTrialClick.bind(_this);
    _this.onBrowseClick = _this.onBrowseClick.bind(_this);
    _this.onBrowseToLinkClick = _this.onBrowseToLinkClick.bind(_this);
    _this.onTermsClick = _this.onTermsClick.bind(_this);
    _this.onAppsClick = _this.onAppsClick.bind(_this);
    _this.onClickContactUs = _this.onClickContactUs.bind(_this);
    _this.onPlanClick = _this.onPlanClick.bind(_this);
    _this.downloadMixerLink = _this.downloadMixerLink.bind(_this);
    _this.customProtocolFallBackForBridge = _this.customProtocolFallBackForBridge.bind(_this);
    _this.customProtocolFallBackForMixer = _this.customProtocolFallBackForMixer.bind(_this);
    _this.customProtocolSuccessForMixer = _this.customProtocolSuccessForMixer.bind(_this);
    _this.customProtocolSuccessForBridge = _this.customProtocolSuccessForBridge.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(TrialPopup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var platform = (0, _utils.detectOperatingSystem)();
      this.setState({ platform: platform });
      // protocol('zpl://screen?pid=5b1798f10fb9498f425baa4f&sid=5c754a7f0823236286bf145f',this.customProtocolFallBackForBridge,this.customProtocolSuccessForBridge);
      // protocol('zpl://screen?pid=5b1798f10fb9498f425baa4f&sid=5c754a7f0823236286bf145f',this.customProtocolFallBackForMixer,this.customProtocolSuccessForMixer);
    }
  }, {
    key: "customProtocolFallBackForBridge",
    value: function customProtocolFallBackForBridge() {
      this.setState({ bridgeNotFound: true });
    }
  }, {
    key: "customProtocolFallBackForMixer",
    value: function customProtocolFallBackForMixer() {
      this.setState({ mixerNotFound: true });
    }
  }, {
    key: "customProtocolSuccessForBridge",
    value: function customProtocolSuccessForBridge() {
      this.setState({ bridgeNotFound: false });
    }
  }, {
    key: "customProtocolSuccessForMixer",
    value: function customProtocolSuccessForMixer() {
      this.setState({ mixerNotFound: false });
    }
  }, {
    key: "onSubscribeClick",
    value: function onSubscribeClick() {
      var onCloseNo = this.props.onCloseNo;
      var router = this.context.router;


      onCloseNo();
      router.push("/pricing");
    }
  }, {
    key: "onTrialClick",
    value: function onTrialClick() {
      var activateTrial = this.props.activateTrial;

      activateTrial();
    }
  }, {
    key: "onBrowseClick",
    value: function onBrowseClick() {
      var onCloseNo = this.props.onCloseNo;
      var router = this.context.router;


      onCloseNo();
      router.push("/megascans/library/free");
    }
  }, {
    key: "onBrowseToLinkClick",
    value: function onBrowseToLinkClick(link) {
      var onCloseNo = this.props.onCloseNo;
      var router = this.context.router;


      onCloseNo();
      router.push(link);
    }
  }, {
    key: "onPlanClick",
    value: function onPlanClick() {
      var onCloseNo = this.props.onCloseNo;
      var router = this.context.router;


      onCloseNo();
      router.push("/pricing");
    }
  }, {
    key: "onAppsClick",
    value: function onAppsClick() {
      var onCloseNo = this.props.onCloseNo;
      var router = this.context.router;


      onCloseNo();
      router.push("/");
    }
  }, {
    key: "onClickContactUs",
    value: function onClickContactUs() {
      var dialogs = this.context.dialogs;

      dialogs.custom(_react2.default.createElement(_components.ContactUsPopupContainer, {
        title: "Contact Us",
        description: "",
        tag: "contact-us",
        initialValues: {
          name: _ramda2.default.propOr("", "name", ""),
          email: _ramda2.default.propOr("", "email", this.props.user.email),
          subject: _ramda2.default.propOr("", "subject", "Contact Us from free Trial Expired."),
          comment: _ramda2.default.propOr("", "comment", "")
        }
      }));
    }
  }, {
    key: "onTermsClick",
    value: function onTermsClick() {
      var onCloseNo = this.props.onCloseNo;
      var router = this.context.router;


      onCloseNo();
      router.push("/terms");
    }
  }, {
    key: "downloadMixerLink",
    value: function downloadMixerLink() {
      var platform = this.state.platform;
      var softwares = this.props.softwares;
      var mixerUpdater = softwares.mixerUpdater;


      var latestStudio = (0, _utils.getLatestVersion)(mixerUpdater, platform);
      var macLink = typeof latestStudio !== "undefined" ? latestStudio.UrlMac : "";
      var windowsLink = typeof latestStudio !== "undefined" ? latestStudio.Url : "";
      var studioDownloadUrl = typeof latestStudio !== "undefined" ? platform.toLowerCase() === "windows" ? latestStudio.Url : latestStudio.UrlMac : "";

      return this.state.mixerNotFound ? studioDownloadUrl : "zpl://screen?pid=5b1798f10fb9498f425baa4f&sid=5c754a7f0823236286bf145f";
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          activating = _props.activating,
          activated = _props.activated,
          error = _props.error,
          trailExpired = _props.trailExpired,
          custom = _props.custom,
          title = _props.title;

      var styles = require("./TrialPopup.scss");
      var icon = "/quixel_2080_logo.png";

      var listPromotion2 = function listPromotion2(mixer, bridge) {
        return [{
          logo: "https://d3uwib8iif8w1p.cloudfront.net/quixel/icons/bridge_icon_2048.png",
          description: "Download 4 times faster. Import custom assets. One click export to your tools.",
          link: {
            to: "",
            iconType: "download",
            linkLable: "download now",
            onClickHandler: function onClickHandler() {
              return _this2.onBrowseToLinkClick("/bridge");
            }
          }
        }, {
          logo: "https://d3uwib8iif8w1p.cloudfront.net/quixel/icons/mixer_icon_2048_preview.png",
          description: "Blend multiple surfaces. Paint, mask & sculpt. Simple layer based workflow.",
          link: {
            to: "",
            iconType: "download",
            linkLable: "download now",
            onClickHandler: function onClickHandler() {
              return _this2.onBrowseToLinkClick("/mixer");
            }
          }
        }];
      };

      var mixerDownloadLink = this.downloadMixerLink();

      var platform = this.state.platform;


      var bridgeDownloadUrl = this.state.bridgeNotFound ? _utils.bridgeBuilds[platform.toLowerCase()] : "zpl://screen?pid=5b1798f10fb9498f425baa4f&sid=5c754a7f0823236286bf145f";

      if (!custom) {
        if (activated) {
          return _react2.default.createElement(
            _Prompt2.default,
            {
              icon: icon,
              title: "welcome to the trial",
              buttonLabel: "not now",
              onSubmit: this.onBrowseClick,
              buttonMode: "transparentWithWhiteBorder",
              textBeforeLinkLabel: "The trial provides non-commercial access only. ",
              linkLabel: "Learn More.",
              onLinkClick: this.onTermsClick
            },
            _react2.default.createElement(
              "p",
              { className: p },
              "Download the apps to get the most of your 30 days!"
            ),
            _react2.default.createElement(
              "div",
              { className: container },
              listPromotion2(mixerDownloadLink, bridgeDownloadUrl).map(function (obj) {
                return _react2.default.createElement(
                  "div",
                  { className: listing2 },
                  _react2.default.createElement(_IconWithDescriptionAndLink2.default, obj)
                );
              })
            )
          );
        }

        if (trailExpired) {
          return _react2.default.createElement(
            _Prompt2.default,
            {
              icon: icon,
              title: "your trial has ended",
              buttonLabel: "choose plan",
              onSubmit: this.onPlanClick,
              textBeforeLinkLabel: "Need help with anything? ",
              linkLabel: "Get in touch",
              onLinkClick: this.onClickContactUs,
              textAfterLinkLabel: " and we\u2019ll get back to you!"
            },
            _react2.default.createElement(
              "p",
              { className: p },
              "Would you like to start a subscription?"
            ),
            _react2.default.createElement(
              "div",
              { className: (0, _glamor.css)(container, { flexDirection: "column" }) },
              listPromotion3.map(function (obj) {
                return _react2.default.createElement(
                  "div",
                  { className: listing2 },
                  _react2.default.createElement(_IconWithDescription2.default, obj)
                );
              })
            )
          );
        }

        return _react2.default.createElement(
          _Prompt2.default,
          {
            icon: icon,
            title: "try 30 days free",
            buttonLabel: "START TRIAL",
            onSubmit: this.onTrialClick,
            onLinkClick: this.onTermsClick,
            linkLabel: "Learn More.",
            textBeforeLinkLabel: "The trial provides non-commercial access only. ",
            loading: activating,
            error: error
          },
          _react2.default.createElement(
            "p",
            { className: p },
            "The 30 day free trial includes:"
          ),
          listPromotion.map(function (obj) {
            return _react2.default.createElement(
              "div",
              { className: listing },
              _react2.default.createElement(_IconWithDescription2.default, obj)
            );
          })
        );
      } else {
        return _react2.default.createElement(
          _Prompt2.default,
          {
            icon: icon,
            title: title,
            buttonLabel: "not now",
            onSubmit: this.onBrowseClick,
            textBeforeLinkLabel: "Need help with anything? ",
            linkLabel: "Get in touch",
            onLinkClick: this.onClickContactUs,
            textAfterLinkLabel: " and we\u2019ll get back to you!"
          },
          _react2.default.createElement(
            "p",
            { className: p },
            "Download the apps to get the most out of your subscription!"
          ),
          _react2.default.createElement(
            "div",
            { className: container },
            listPromotion2(mixerDownloadLink, bridgeDownloadUrl).map(function (obj) {
              return _react2.default.createElement(
                "div",
                { className: listing2 },
                _react2.default.createElement(_IconWithDescriptionAndLink2.default, obj)
              );
            })
          )
        );
      }
    }
  }]);
  return TrialPopup;
}(_react2.default.Component), _class2.contextTypes = {
  router: _react.PropTypes.object,
  dialogs: _react2.default.PropTypes.object
}, _temp)) || _class) || _class);
exports.default = TrialPopup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TrialPopup/TrialPopup.jsx
// module id = 2834
// module chunks = 0